import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';
import { HttpClient, HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class FontsService {
  private url = 'fonts';
  constructor(private httpClient: HttpClientService) {}
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  searchOptions(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  delete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }
  show(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/${params.fontId}.json`, params);
  }
  update(params: any = {}): Promise<any> {
    return this.httpClient.put(`${this.url}/${params.fontId}.json`, params);
  }
}
